import { DatabaseClient } from '../DatabaseClient';

export async function getUserVersion(client: DatabaseClient): Promise<number> {
  const result = await client.executeSql('PRAGMA user_version', []);
  if (result.rows.length > 0) {
    const parsed = Number(result.rows.item(0).user_version);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }
  }
  return 0;
}

export async function setUserVersion(client: DatabaseClient, version: number): Promise<void> {
  await client.executeSql(`PRAGMA user_version = ${version}`, []);
}
